<template>
  <div class="maintenance-page">
    <div class="maintenance-box">
      <h1><v-icon x-large class="mr-3 red--text">mdi-alert</v-icon>Site Maintenance</h1>
      <p>
        The website is temporarily unavailable for maintenance.<br>
        Please try again later.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Maintenance'
}
</script>

<style scoped>
.maintenance-page {
  min-height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f4f7f6, #dfeae6);
  padding: 30px;
}

.maintenance-box {
  max-width: 600px;
  width: 100%;
  text-align: center;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.08);
  padding: 40px 30px;
}

h1 {
  font-size: 2.2rem;
  color: #1f4f43;
  margin-bottom: 16px;
}

p {
  font-size: 1.05rem;
  line-height: 1.8;
  color: #3a3a3a;
  margin: 0;
}
</style>
